import {
  PLACEMENT_TYPE_BULLET,
  PLACEMENT_TYPE_BULLET_DROPBOX,
  PLACEMENT_TYPE_BULLET_PICKUP,
  PLACEMENT_TYPE_CHIP,
  PLACEMENT_TYPE_CIABATTA,
  PLACEMENT_TYPE_CIABATTA_BLAST,
  PLACEMENT_TYPE_CLOWN_DEFENSE_PICKUP,
  PLACEMENT_TYPE_CONVEYOR,
  PLACEMENT_TYPE_DEAD_CLOWN,
  PLACEMENT_TYPE_ENEMY,
  PLACEMENT_TYPE_ENEMY_SPAWN,
  PLACEMENT_TYPE_FIRE,
  PLACEMENT_TYPE_FIREBOOTS_PICKUP,
  PLACEMENT_TYPE_FLYING_ENEMY,
  PLACEMENT_TYPE_GOAL,
  PLACEMENT_TYPE_HERO,
  PLACEMENT_TYPE_HERO_SPAWN,
  PLACEMENT_TYPE_ICE,
  PLACEMENT_TYPE_ICEBOOTS_PICKUP,
  PLACEMENT_TYPE_KEY,
  PLACEMENT_TYPE_LOCK,
  PLACEMENT_TYPE_PARTICLE,
  PLACEMENT_TYPE_ROAMING_ENEMY,
  PLACEMENT_TYPE_SWITCH,
  PLACEMENT_TYPE_SWITCH_WALL,
  PLACEMENT_TYPE_TELEPORT,
  PLACEMENT_TYPE_THIEF,
  PLACEMENT_TYPE_WALL,
  PLACEMENT_TYPE_WARNING,
  PLACEMENT_TYPE_WATER,
  PLACEMENT_TYPE_WATER_PICKUP,
} from "../helpers/consts";
import { HeroPlacement } from "../game-objects/HeroPlacement";
import { WallPlacement } from "../game-objects/WallPlacement";
import { WaterTilePlacement } from "../game-objects/WaterTilePlacement";
import { IceTilePlacement } from "../game-objects/IceTilePlacement";
import { FireTilePlacement } from "../game-objects/FireTilePlacement";
import { ConveyorTilePlacement } from "../game-objects/ConveyorTilePlacement";
import { KeyPickupPlacement } from "../game-objects/KeyPickupPlacement";
import { LockPlacement } from "../game-objects/LockPlacement";
import { SwitchButtonPlacement } from "../game-objects/SwitchButtonPlacement";
import { SwitchableWallPlacement } from "../game-objects/SwitchableWallPlacement";
import { FlourPickupPlacement } from "../game-objects/FlourPickupPlacement";
import { FireBootsPickupPlacement } from "../game-objects/FirePickupPlacement";
import { IceBootsPickupPlacement } from "../game-objects/IcePickupPlacement";
import { WaterGogglesPickupPlacement } from "../game-objects/WaterPickupPlacement";
import { GoalTilePlacement } from "../game-objects/GoalTilePlacement";
import { EnemyPlacement } from "../game-objects/EnemyPlacement";
import { RoamingEnemyPlacement } from "../game-objects/RoamingEnemyPlacement";
import { FlyingEnemyPlacement } from "../game-objects/FlyingEnemyPlacement";
import { TeleportPlacement } from "../game-objects/TeleportPlacement";
import { ThiefPlacement } from "../game-objects/ThiefPlacement";
import { EnemySpawnPlacement } from "../game-objects/EnemySpawnPlacement";
import { HeroSpawnPlacement } from "../game-objects/HeroSpawnPlacement";
import { makeRandomId } from "../helpers/makeRandomId";
import { CiabattaPlacement } from "../game-objects/CiabattaPlacement";
import { CiabattaBulletPlacement } from "../game-objects/CiabattaBulletPlacement";
import { BulletPickupPlacement } from "../game-objects/BulletPickupPlacement";
import { BulletDropboxPlacement } from "../game-objects/BulletDropboxPlacement";
import { BulletPlacement } from "../game-objects/BulletPlacement";
import { WarningPlacement } from "../game-objects/WarningPlacement";
import { ParticleExlosionPlacement } from "../game-objects/ParticleExlosionPlacement";
import { DeadClownPlacement } from "../game-objects/DeadClownPlacement";
import { ClownDefensePickupPlacement } from "../game-objects/ClownDefensePickupPlacement";

class PlacementFactory {
  createPlacement(placementConfig, forLevel) {
    const instance = this.getInstance(placementConfig, forLevel);
    instance.id = makeRandomId();
    return instance;
  }

  getInstance(data, forLevel) {
    switch (data.type) {
      case PLACEMENT_TYPE_HERO:
        return new HeroPlacement(data, forLevel);
      case PLACEMENT_TYPE_WALL:
        return new WallPlacement(data, forLevel);
      case PLACEMENT_TYPE_WATER:
        return new WaterTilePlacement(data, forLevel);
      case PLACEMENT_TYPE_ICE:
        return new IceTilePlacement(data, forLevel);
      case PLACEMENT_TYPE_FIRE:
        return new FireTilePlacement(data, forLevel);
      case PLACEMENT_TYPE_CONVEYOR:
        return new ConveyorTilePlacement(data, forLevel);
      case PLACEMENT_TYPE_KEY:
        return new KeyPickupPlacement(data, forLevel);
      case PLACEMENT_TYPE_LOCK:
        return new LockPlacement(data, forLevel);
      case PLACEMENT_TYPE_SWITCH:
        return new SwitchButtonPlacement(data, forLevel);
      case PLACEMENT_TYPE_SWITCH_WALL:
        return new SwitchableWallPlacement(data, forLevel);
      case PLACEMENT_TYPE_CHIP:
        return new FlourPickupPlacement(data, forLevel);
      case PLACEMENT_TYPE_FIREBOOTS_PICKUP:
        return new FireBootsPickupPlacement(data, forLevel);
      case PLACEMENT_TYPE_ICEBOOTS_PICKUP:
        return new IceBootsPickupPlacement(data, forLevel);
      case PLACEMENT_TYPE_WATER_PICKUP:
        return new WaterGogglesPickupPlacement(data, forLevel);
      case PLACEMENT_TYPE_GOAL:
        return new GoalTilePlacement(data, forLevel);
      case PLACEMENT_TYPE_ENEMY:
        return new EnemyPlacement(data, forLevel);
      case PLACEMENT_TYPE_ROAMING_ENEMY:
        return new RoamingEnemyPlacement(data, forLevel);
      case PLACEMENT_TYPE_FLYING_ENEMY:
        return new FlyingEnemyPlacement(data, forLevel);
      case PLACEMENT_TYPE_TELEPORT:
        return new TeleportPlacement(data, forLevel);
      case PLACEMENT_TYPE_THIEF:
        return new ThiefPlacement(data, forLevel);
      case PLACEMENT_TYPE_ENEMY_SPAWN:
        return new EnemySpawnPlacement(data, forLevel);
      case PLACEMENT_TYPE_HERO_SPAWN:
        return new HeroSpawnPlacement(data, forLevel);
      case PLACEMENT_TYPE_CIABATTA:
        return new CiabattaPlacement(data, forLevel);
      case PLACEMENT_TYPE_CIABATTA_BLAST:
        return new CiabattaBulletPlacement(data, forLevel);
      case PLACEMENT_TYPE_BULLET_PICKUP:
        return new BulletPickupPlacement(data, forLevel);
      case PLACEMENT_TYPE_BULLET_DROPBOX:
        return new BulletDropboxPlacement(data, forLevel);
      case PLACEMENT_TYPE_BULLET:
        return new BulletPlacement(data, forLevel);
      case PLACEMENT_TYPE_WARNING:
        return new WarningPlacement(data, forLevel);
      case PLACEMENT_TYPE_PARTICLE:
        return new ParticleExlosionPlacement(data, forLevel);
      case PLACEMENT_TYPE_DEAD_CLOWN:
        return new DeadClownPlacement(data, forLevel);
      case PLACEMENT_TYPE_CLOWN_DEFENSE_PICKUP:
        return new ClownDefensePickupPlacement(data, forLevel);

      default: {
        console.warn("Type not found", data.type);
        return null;
      }
    }
  }
}

const placementFactory = new PlacementFactory();

export default placementFactory;
